<p-dialog header="{{ 'ReceiptFormCopy.CopyReciptForm' | translate }}" [(visible)]="isVisible" appendTo="body" (visibleChange)="dialogVisibleChange($event)"
  [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '80%'  }">

  <form [formGroup]="copyForm">

    <div class="p-fluid mt-2">

      <div class="field grid">
        <label class="col-2" ><span class="requiredStart">*</span>{{ 'ReceiptFormCopy.AWBNum' | translate }}</label>
        <div class="col-4">
          <input pInputText type="text" formControlName="hawbNo"   />
        </div>
      </div>


      <div class="field grid">
        <label class="col-2" >{{ 'ReceiptFormCopy.NumPallets' | translate }}</label>
        <div class="col-4">
          <p-inputNumber   formControlName="palletCnt" ></p-inputNumber>
        </div>
      </div>


      <div class="field grid">
        <label class="col-2" ><span class="requiredStart">*</span>{{ 'ReceiptFormCopy.TotalCartonCnt' | translate }}</label>
        <div class="col-4">
          <p-inputNumber   formControlName="totalCartonCnt" ></p-inputNumber>
        </div>
      </div>

      <div class="field grid">
        <label class="col-2" ><span class="requiredStart">*</span>{{ 'ReceiptFormCopy.ReceivingTotalChareableWeight' | translate }}</label>
        <div class="col-4">
          <p-inputNumber   formControlName="totalChareableWeight" mode="decimal" [minFractionDigits]="2" ></p-inputNumber>
        </div>
      </div>

      <div class="field grid">
        <label class="col-2" >{{ 'ReceiptFormCopy.TotalGrossWeight' | translate }}</label>
        <div class="col-4">
          <p-inputNumber   formControlName="totalGrossWeight" mode="decimal" [minFractionDigits]="2" ></p-inputNumber>
        </div>
      </div>

      <div class="field grid">
        <label class="col-2" >{{ 'ReceiptFormCopy.TotalVolumeWeight' | translate }}</label>
        <div class="col-4">
          <p-inputNumber   formControlName="totalVolumeWeight" mode="decimal" [minFractionDigits]="2" ></p-inputNumber>
        </div>
      </div>

      <div class="field grid">
        <label class="col-2" ><span class="requiredStart">*</span>{{ 'ReceiptFormCopy.Supplier' | translate }}</label>
        <div class="col-4">
          <p-autoComplete formControlName="vendorCustomer" [suggestions]="vendorSuggests" (completeMethod)="getVendorOptions($event)"></p-autoComplete>
        </div>
      </div>

      <div class="field grid">
        <label class="col-2" >{{ 'ReceiptFormCopy.CalculationUnit' | translate }}</label>
        <div class="col-4">
          <p-dropdown formControlName="uom" optionLabel="label" optionValue="value"
          [options]="carTypeOptions"   styleClass="p-text-left" [showClear]="true"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  ></p-dropdown>
        </div>
      </div>

      <div class="field grid">
        <label class="col-2" >{{ 'ReceiptFormCopy.IdentificaitonNum' | translate }}</label>
        <div class="grid align-center vertical-container">
          <div class="col"><input pInputText formControlName="docNo1" maxlength="2" /> </div><span>/</span>
          <div class="col"><input pInputText formControlName="docNo2" maxlength="2" /> </div><span>/</span>
          <div class="col"><input pInputText formControlName="docNo3" maxlength="2" /> </div><span>/</span>
          <div class="col"><input pInputText formControlName="docNo4" maxlength="4" /> </div><span>/</span>
          <div class="col"><input pInputText formControlName="docNo5" maxlength="5" /> </div>
        </div>
        <small *ngIf="(f.docNo1.errors || f.docNo2.errors || f.docNo3.errors || f.docNo4.errors || f.docNo5.errors)" class="errors">
          <div *ngIf="f.docNo1.errors?.fullWidth || f.docNo2.errors?.fullWidth || f.docNo3.errors?.fullWidth || f.docNo4.errors?.fullWidth || f.docNo5.errors?.fullWidth" class="p-invalid">請輸入半形字符</div>
        </small>
      </div>

      <div class="field grid">
        <label class="col-2" >{{ 'ReceiptFormCopy.MambNo' | translate }}</label>
        <div class="col-4">
          <input pInputText type="text" formControlName="mawbNo" />
        </div>
      </div>

    </div>


    <div class="mt-2 text-center">
      <button pRipple pButton label="{{ 'ReceiptFormCopy.Copy' | translate }}"
        (click)="confirmBtnClick($event)"></button>
      <button pRipple pButton label="{{ 'Common.Button.Cancel' | translate }}" class="p-button-secondary ml-2"
        (click)="cancelBtnClick($event)"></button>
    </div>

  </form>

</p-dialog>
